import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "../../../environments/environment";
@Component({
  selector: 'app-billing-header',
  templateUrl: './billing-header.component.html',
  styleUrl: './billing-header.component.scss',
  standalone: false
})
export class BillingHeaderComponent {
  selectedIndex: number = 0;
  is_ignite = false;

  constructor(private router: Router) { }


  ngOnInit() {
    const host = window.location.hostname;
    const route = this.router.url;
    if (host === environment.igniteDomain) {
      this.is_ignite = true;
      if (route.includes('/dashboard')) this.selectedIndex = 0;
      if (route.includes('/billing')) this.selectedIndex = 1;
      else if (route.includes('/payment-methods')) this.selectedIndex = 2;
      else if (route.includes('/subscription')) this.selectedIndex = 3;
      else if (route.includes('/transactions')) this.selectedIndex = 4;
    }
    else {
      if (route.includes('/billing')) this.selectedIndex = 1;
    }

  }

  onTabClick(index: number) {
    const host = window.location.hostname;
    if (host === environment.igniteDomain) {
      this.is_ignite = true;
      const routes = [
        '/dashboard',
        '/billing',
        '/payment-methods',
        '/subscription',
        '/transactions'
      ];
      this.router.navigate([routes[index]]);
    }
    else {
      this.router.navigate(['/billing']);
    }
  }
}
